<div class="game-paginator" *ngIf="total > 0">
  <div class="progress-text">
    <span>{{ curNum }} / {{ total }}</span>
    <div class="bar">
      <div class="progress" [style.width]="progress + '%'"></div>
    </div>
    <span>{{ (curNum / total) * 100 | tostring : 0 }}%</span>
  </div>
  <div
    class="load-btn mutual-opacity onact96"
    [class.disabled]="!hasMore || disabled"
    [class.loading]="loading"
    (click)="loadNextPage()"
  >
    <span *ngIf="!loading">{{ (hasMore ? 'load_m' : 'no_more') | translate }}</span>
    <app-dot-loading *ngIf="loading" [sizeByFont]="false"></app-dot-loading>
  </div>
</div>
